import { createFileRoute, notFound } from '@tanstack/react-router';
import { MyAbsencesPage } from '@/features/resources/absences/my-absences-page';
import { requireResourcesFeature } from '@/features/resources/guard';

/** Own absences; internal users only (the API answers 404 to external users). */
export const Route = createFileRoute('/_app/absences')({
  beforeLoad: async ({ context }) => {
    if (context.me.user.userType !== 'internal') throw notFound();
    await requireResourcesFeature(context.queryClient);
  },
  component: MyAbsencesPage,
});
